import React, { useEffect, useState } from 'react';
import { useNavigate, useSearchParams } from 'react-router-dom';
import { isObjectEmpty, stringIsNullOrEmpty } from '../../common/util';
import { useTranslation } from 'react-i18next';
import { colorError } from '../../shared/theme';
import { ApiKey, Page, PaymentStatus } from '../../common/constant';
import { QRCode, Spin, Typography } from 'antd';
import TransactionService from '../../services/transaction_service';

/**
 * @author Nelson
 * @returns 
 */
const DuitnowPayment = () => {
    const _transactionService = new TransactionService();
    const { t } = useTranslation();
    const [searchParams] = useSearchParams();
    const signature = searchParams.get("signature");
    const code = searchParams.get("code");
    const transactionId = searchParams.get("transactionId");
    const amount = searchParams.get("amount");
    const phoneNumber = searchParams.get("phoneNumber");
    const name = searchParams.get("name");
    const address = searchParams.get("address");
    const sellerPhoneNumber = searchParams.get("sellerPhoneNumber");
    const navigate = useNavigate();
    const [timeLeft, setTimeLeft] = useState(null);
    const [qrValidUntil, setQrValidUntil] = useState(null);
    const [loading, setLoading] = useState(true);
    const [qrDetail, setQrDetail] = useState(null);

    /**
     * @author Nelson
     */
    useEffect(() => {
        let intervalId;
        const initPayment = async () => {
            try {
                setLoading(true);
                console.log(amount, signature, phoneNumber, name, address, transactionId, code);

                if (!stringIsNullOrEmpty(signature) && !isNaN(amount) && parseFloat(amount) > 0 && parseFloat(amount) < 500 && !stringIsNullOrEmpty(phoneNumber) && !stringIsNullOrEmpty(name) && !stringIsNullOrEmpty(address) && !stringIsNullOrEmpty(transactionId) && !stringIsNullOrEmpty(code)) {
                    (
                        async () => {
                            let response = await _transactionService.initQrPayment({
                                signature,
                                code,
                                vendorTransactionId: transactionId,
                                amount,
                                phoneNumber,
                                sellerPhoneNumber,
                                name,
                                address,
                            });
                            if (response[ApiKey._SUCCESS_KEY] && !isObjectEmpty(response[ApiKey._DATA_KEY])) {
                                console.log(response[ApiKey._DATA_KEY])
                                const responseDataJson = response[ApiKey._DATA_KEY]
                                setQrDetail(responseDataJson);
                                setQrValidUntil(responseDataJson.qrValidUntil)

                                const checkPaymentStatus = async () => {
                                    try {
                                        const { userId, transactionId, vendorTransactionId } = responseDataJson
                                        const statusResponse = await _transactionService.checkQrPaymentStatus({ userId, transactionId, vendorTransactionId, signature, code });

                                        if (statusResponse.data.status === PaymentStatus._SUCCESS || statusResponse.data.status === PaymentStatus._FAILED) {
                                            clearInterval(intervalId);
                                            navigate(Page._PAYMENT_RESULT, {
                                                replace: true,
                                                state: { response: statusResponse }
                                            });
                                        }
                                    } catch (error) {
                                        handlePaymentStatus();
                                    }
                                };

                                intervalId = setInterval(checkPaymentStatus, 3500);
                            }
                            else {
                                throw '';
                            }
                        }
                    )();
                }
                else {
                    throw '';
                }
            } catch (error) {
                handlePaymentStatus();
            } finally {
                setLoading(false);
            }
        };

        initPayment();
        return () => clearInterval(intervalId);
    }, [signature, amount]);

    /// <summary>
    /// Author: Wei Xiang
    /// </summary>
    useEffect(() => {
        let interval
        if (qrValidUntil !== null) {
            interval = setInterval(() => {
                const remainingTime = calculateTimeLeft(qrValidUntil);
                setTimeLeft(remainingTime);

                if (qrValidUntil !== null && remainingTime <= 0) {
                    clearInterval(interval);
                    const response = {
                        title: t("PAYMENT_FAILED"),
                        message: t("QR_CODE_TIMEOUT"),
                        icon: {
                            name: 'times-circle',
                            color: colorError,
                        },
                    };
                    navigate(Page._PAYMENT_RESULT, { state: { response }, replace: true });
                }
            }, 1000);
        }

        return () => clearInterval(interval);
    }, [qrValidUntil]);


    function calculateTimeLeft(expiry) {
        const now = new Date();
        const expiryTime = new Date(expiry);
        const diff = expiryTime - now;
        return diff > 0 ? diff : 0;
    }

    function formatTime(milliseconds) {
        const totalSeconds = Math.floor(milliseconds / 1000);
        const minutes = Math.floor(totalSeconds / 60);
        const seconds = totalSeconds % 60;
        return `${minutes}:${seconds.toString().padStart(2, '0')}`;
    }

    const handlePaymentStatus = () => {
        const response = {
            title: t("PAYMENT_FAILED"),
            message: t("CONTACT_ADMIN_FOR_HELP"),
            icon: {
                name: 'times-circle',
                color: colorError,
            },
        };

        // navigate(Page._PAYMENT_RESULT, { state: { response }, replace: true });
    };

    return (
        <div style={{
            display: 'flex',
            justifyContent: 'center',
            alignItems: 'center',
            height: '100%',
            minHeight: '100dvh',
            backgroundColor: '#f0f2f5'
        }}>
            {loading || timeLeft === null ? (
                <Spin size="large" style={{ display: 'flex', justifyContent: 'center', alignItems: 'center', height: '100vh' }} />
            ) :
                <div style={{
                    width: '320px',
                    padding: '20px 20px 35px 20px',
                    backgroundColor: '#fff',
                    borderRadius: '8px',
                    boxShadow: '0px 4px 6px rgba(0, 0, 0, 0.1)',
                    display: 'flex',
                    flexDirection: 'column',
                    justifyContent: 'center',
                    alignItems: 'center'
                }}>
                    <img src={require('../../assets/images/duitnow.png')} width={"70px"} />
                    <Typography.Text style={{ textAlign: "center", marginTop: 12 }}>Kindly scan the QR code below to proceed with payment</Typography.Text>
                    <Typography.Text style={{ textAlign: "center" }}>Please do not refresh the page</Typography.Text>
                    <Typography.Text style={{ textAlign: "center", marginTop: 4, marginBottom: 12, fontWeight: "bold" }}>Expires in {formatTime(timeLeft)}</Typography.Text>
                    <div style={{ background: "#ed2a67", padding: 12, textAlign: "center", borderRadius: "8px" }}>
                        <Typography.Title level={4} style={{ margin: 0, marginBottom: 12, color: 'white' }}>RM {parseFloat(amount).toFixed(2)}</Typography.Title>
                        <QRCode value={qrDetail?.qrPayload} size={240} status={qrDetail?.qrPayload ? "active" : "loading"} color={"#ed2a67"} bgColor={"white"} style={{ marginBottom: 8 }} />
                        <Typography.Text style={{ color: 'white', fontWeight: "bold" }}>MALAYSIA NATIONAL QR</Typography.Text>
                    </div>
                </div >}
        </div >
    )
};

export default DuitnowPayment;